var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeartIconNav = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.591 5.175a3.745 3.745 0 0 0-5.445 0c-1.528 1.586-1.528 4.172 0 5.758l.04.044L12 18.961l6.813-7.984.04-.044c1.529-1.586 1.529-4.172 0-5.758a3.745 3.745 0 0 0-5.444 0L12 6.637zM12 3.755a5.744 5.744 0 0 0-8.294.032c-2.267 2.353-2.275 6.149-.022 8.51L12 22.043l8.316-9.744c2.253-2.362 2.245-6.158-.022-8.51A5.744 5.744 0 0 0 12 3.754",
    clipRule: "evenodd"
  })));
};
export default SvgHeartIconNav;